<template>
  <BtnToggle 
    :title="$t('engine.manageText.modalWidget.tooltip.lblImage', languageEngine)"
    @click="chooseImage"
    @click_="addImage()"
  >
    <i class="far fa-image fs-16"></i>
  </BtnToggle>
</template>

<script>
import { mapGetters } from "vuex";
import BtnToggle from "./_BtnToggle";

export default {
  components: {
    BtnToggle,
  },
  computed: {
    ...mapGetters({
      languageEngine: "designIframe/userPreference/languageEngine",
      texteditor: "designIframe/texteditor/texteditor",
    }),
    selectionFormat() {
      return this.texteditor.selectionFormat;
    },
    selectionFormatMerge() {
      return this.texteditor.selectionFormatMerge;
    },
  },
  methods: {
    chooseImage() {
      this.$store.dispatch("designIframe/texteditor/setData", { forceFocus: true });
      this.$store.dispatch("designIframe/modals/setModal", {
        modal_id: "modal-filemanager",
        payload: {
          componentConfig: {
            type: "texteditor-image",
          },
          limit: 1,
          selectDirectoryType: 'system',
          isShowImage: true,
          isShowDocument: false,
          isShowUnsplash: false,
          isShowFlaticon: false,
          isShowIcon: false,
        },
        callback:{
          onSubmit: (value) => {
            this.addImage(value);
          },
          onClose: () => {
            this.$store.dispatch("designIframe/texteditor/setData", { forceFocus: false });
          },
        },
      });
    },
    async getBase64(url) {
      const data = await fetch(url);
      const blob = await data.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob); 
        reader.onloadend = () => {
          const base64data = reader.result;   
          resolve(base64data);
        }
      });
    },
    async addImage(value) {
      if (!value) return;

      const selection = this.texteditor.editor.getSelection();
      let url = String(value.file.url).replace('{{size}}', 'r_0x200');
      let width = value.file.width;
      let height = value.file.height;
      let alt = value.file.alt;
      let title = value.file.title;

      this.texteditor.editor.insertEmbed(selection.index + selection.length, 'image-icon', url);
      this.texteditor.editor.formatText({ index: selection.index + selection.length, length: 1 }, { ...this.selectionFormat, width, height, alt, title });
      if (selection.length > 0) {
        this.texteditor.editor.deleteText(selection);
      }

      setTimeout(() => {
        this.$store.dispatch("designIframe/frame/reRenderFrame");
        this.$store.dispatch("designIframe/texteditor/reContainer");
        setTimeout(() => {
          this.texteditor.editor.setSelection(selection.index + 1, 0); // selection next
        }, 500); // wait this is last focus
      }, 500); // wait image loaded
    },
  },
}
</script>
